<app-service-settings-common
    [defaultData]="store.medicationSettings()"
    [title]="'service.settings.medication.header'"
>
    <ng-template #additionalContent>
        <p-divider></p-divider>
        <app-check-input
            id="showColumnTimesAdministrated"
            [form]="form"
            label="service.settings.medication.showColumnTimesAdministrated"
        ></app-check-input>
        <app-check-input
            id="showConnectWithProcedureOption"
            [form]="form"
            label="service.settings.medication.showConnectWithProcedureOption"
        ></app-check-input>
        <!-- TODO: Do we still need that? -->
        @if (false) {
            <app-select-input
                id="windowType"
                [form]="form"
                label="service.settings.medication.windowType"
                [staticOptions]="windowTypeOptions"
                [valueKey]="null">
                <ng-template #item let-data>
                    {{ ('service.settings.medication.windowTypeOptions.' + (data?.name ?? data)) | translate }}
                </ng-template>
                <ng-template #selectedItem let-data>
                    {{ ('service.settings.medication.windowTypeOptions.' + (data?.name ?? data)) | translate }}
                </ng-template>
            </app-select-input>
        }
    </ng-template>
    <ng-template #footer>
        <app-action-buttons
            (primaryClickEvent)="save()"
            (secondaryClickEvent)="cancel()"
        ></app-action-buttons>
    </ng-template>
</app-service-settings-common>
